import { render } from "./NotaPortfolioCard.vue?vue&type=template&id=34956ada"
import script from "./NotaPortfolioCard.vue?vue&type=script&lang=js"
export * from "./NotaPortfolioCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__